import { Stack, Text, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import { BsPerson } from "react-icons/bs";
import { MdOutlineAttachMoney, MdOutlinePrivacyTip } from "react-icons/md";
import { AiOutlineLogout } from "react-icons/ai";
import { RiSearchEyeLine } from "react-icons/ri";
import { signOut } from "@firebase/auth";
import { auth, db } from "../../service/firebase";
import { useGetState } from "../../context/useGetState";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { _CLEAR_ALL_SESSIONS } from "../signin/SignIn";
import { BiSolidGroup } from "react-icons/bi";

export const ProfileSideBar = ({ setCurrentTab }) => {
  const textColor = useColorModeValue("#767676", "#fff");
  const iconColor = useColorModeValue("#767676", "#fff");
  const logoutColor = useColorModeValue("#FE4045", "#fff");
  const { state } = useGetState();
  const userId = state?.userInfo?.firebase_token;

  let style = {
    direction: "row",
    alignItems: "center",
    cursor: "pointer",
  };
  const list = [
    {
      icon: <RiSearchEyeLine color={iconColor} size={".9em"} />,
      title: "Overview",
      tab: 0,
    },
    {
      icon: <BsPerson color={iconColor} size={".9em"} />,
      title: "Verification",
      tab: 2,
    },
    // {
    //   icon: <MdOutlineAttachMoney color={iconColor} size={".9em"} />,
    //   title: "Earnings",
    //   tab: 3,
    // },
    {
      icon: <MdOutlinePrivacyTip color={iconColor} size={".9em"} />,
      title: "Privacy Policy",
      tab: 4,
    },
  ];

  const setOffline = async () => {
    const onlineState = await getDoc(doc(db, "isOnline", userId));
    if (onlineState.exists()) {
      await updateDoc(doc(db, "isOnline", userId), {
        online: false,
      });
    } else {
      await setDoc(doc(db, "isOnline", userId), {
        online: false,
      });
    }
  };

  const handleLogout = async () => {
    await setOffline();
    _CLEAR_ALL_SESSIONS();
    await signOut(auth);

    window.location.reload();
  };
  return (
    <Stack color={textColor} spacing="50px">
      {list?.map(({ icon, title, tab }) => {
        return (
          <Stack {...style}>
            {icon}
            <Text onClick={() => setCurrentTab(tab)} fontSize={".7em"}>
              {title}
            </Text>
          </Stack>
        );
      })}
      <Stack
        {...style}
        color="#FE4045"
        fontWeight={"semibold"}
        onClick={() => {
          handleLogout();
        }}
      >
        <AiOutlineLogout size={".9em"} color={logoutColor} />
        <Text fontSize={".7em"}>Log Out</Text>
      </Stack>
    </Stack>
  );
};
